import { PrinterIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'
import { useNavigate, useParams } from 'libs/router'
import { routes } from 'config/routes'
import {
	BackButton,
	CardWrapper,
	CtaButton,
	Header,
	HistoryButton,
	NotFound
} from 'shared/components'
import { Spinner } from 'shared/atoms'
import { PayoutForm } from 'features/payouts/organisms/PayoutForm/PayoutForm'
import { usePrintPayout } from 'features/payouts/hooks/usePrintPayout'
import { useFetchPayout } from './queries/useFetchPayout'

const PayoutPage = () => {
	const { t } = useTranslation()
	const params = useParams()
	const navigate = useNavigate()
	const { payout, isPayoutNotFound } = useFetchPayout()
	const { printPayout } = usePrintPayout()

	if (isPayoutNotFound) {
		return (
			<NotFound
				title={t('Payout not found')}
				description={t('The payout “{{ id }}” does not exist.', { id: params.id })}
				backTo={routes.payoutIndex}
				backText={t('Back to payouts')}
			/>
		)
	}

	return (
		<>
			<Header
				title={payout ? t('Payout #{{ id }}', { id: payout.data.reference }) : t('Payout')}
				actions={
					<>
						<BackButton to={routes.payoutIndex} text={t('Back to payouts')} />
						{payout && (
							<CtaButton
								text={t('Print')}
								icon={<PrinterIcon />}
								variant="outline"
								compact
								onClick={() => printPayout(payout.data.id)}
							/>
						)}
						<HistoryButton to={routes.payoutHistory(params.id)} />
					</>
				}
			/>
			<div className="mx-auto max-w-[704px] px-5 lg:px-0">
				<CardWrapper className="p-5">
					{payout ? (
						<PayoutForm payout={payout.data} onSuccess={() => navigate(routes.payoutIndex)} />
					) : (
						<div className="flex justify-center py-12">
							<Spinner />
						</div>
					)}
				</CardWrapper>
			</div>
		</>
	)
}

export default PayoutPage
